import { sentryCaptureException } from '@alfa-bank/site-helpers-error-handlers/sentry-logger/capture-exception';
import { sentryAddErrorBreadcrumb } from '@alfa-bank/site-helpers-error-handlers/sentry-logger/breadcrumb';

import type { IPublicProps } from '../models';

export const onSentryCaptureException =
    (sentryCaptureExceptionConfig: IPublicProps['sentryCaptureException']) => (error: unknown) => {
        console.error(error);

        sentryAddErrorBreadcrumb({
            message: 'firstStepDraft error',
        });

        sentryCaptureException(error, sentryCaptureExceptionConfig);
    };
